import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ContentContainer } from 'src/components/common/ContentContainer/contentContainer';
import { customWidths } from 'src/utils/constants';

export const Summary = () => {
	const { t } = useTranslation();

	return (
		<ContentContainer>
			<Flex
				display={{ base: 'none', md: 'flex' }}
				width={customWidths.pageWidth}
				margin="100px 0px"
				gridGap="20px"
				justifyContent="center"
				alignItems="center"
				color="white"
				flexDirection="column"
			>
				<Heading>{t('pages.addGame.success')}</Heading>
				<Text
					margin="10px 0px"
					fontSize="14px"
					color="gray"
				>
					{t('pages.addGame.submitted')}
				</Text>
				<Link to="/">
					<Button variant="ghost">OK</Button>
				</Link>
			</Flex>
		</ContentContainer>
	);
};
